export const DISBURSEMENTS_ACH = "disbursements-ach";
export const BATCHES_ESCHEATMENTS = "batches-escheatments";
export const QANDP_POLICY_VITALS = "qandp-policy-vitals";
export const REFERRALS_POWER_UP_STATUS_FILTER =
  "referrals-power-up-status-filter";
export const REFERRALS_PRODUCT_FILTER = "referrals-product-filter";
export const REFERRALS_STATE_FILTER = "referrals-state-filter";
export const REFERRALS_PIC_FILTER = "referrals-pic-filter";
export const REFERRALS_SURE_FILTER = "referrals-sure-filter";
export const REFERRALS_SRCH_FILTER = "referrals-srch-filter";
export const REFERRALS_LEGACY_LINK = "referrals-legacy-linking";
export const QANDP_ACCOUNTING_FORMS = "q-p-accounting-forms";
export const QANDP_POLICY_MANAGER_FORMS = "q-p-policy-manager-forms";
export const QANDP_PRINT_AND_MAIL_DOCUMENTS = "q-p-print-and-mail-documents";
export const QANDP_SAVE_ACH_INFO = "q-p-save-ach-info";
export const QANDP_DOCUSIGN = "q-p-docusign";
export const QANDP_EASYPAY_INFO = "q-p-easy-pay-account-information";
export const QANDP_RENEWAL_UNDERWRITING = "q-p-renewal-underwriting";
export const QANDP_UNDERWRITING_REFERRALS = "q-p-underwriting-referrals";
export const QANDP_VIEW_ADVANCED = "q-p-view-advanced";
export const QANDP_POLICY_INSPECTIONS = "q-p-policy-inspections";
export const QANDP_LEGACY_VIEW = "q-p-legacy-view";
export const QANDP_SERVICE_REQUESTS_DEMO = "q-p-service-requests-demo";
export const QANDP_MANAGE_ASSIGNEES = "q-p-manage-assignees";
export const QANDP_NON_RENEW_INDICATOR = "q-p-non-renew-indicator";
export const QANDP_PAST_TERMS = "q-p-past-terms";
export const QANDP_ODEN_CANCELLATION = "q-p-oden-pending-cancel";
export const QANDP_VOID_PAYMENT = "q-p-void-payment";
export const QANDP_RELOCATED_SUMMARY_BUTTONS = "q-p-relocated-summary-buttons";
export const QANDP_PAPERLESS_ENROLLMENT = "q-p-paperless-enrollment";
export const QANDP_SAME_DAY_MAIL = "q-p-same-day-mail";
export const QANDP_QUOTING_SUPPORT = "q-p-quoting-support";
export const QANDP_QUOTING_SUPPORT_SAVE_BUTTON =
  "q-p-quoting-support-save-button";
export const QANDP_UNDERWRITING_CONDITIONS_SELECTOR =
  "q-p-underwriting-conditions-selector";
export const QANDP_DO_NOT_REINSTATE_FLAG = "q-p-do-not-reinstate-flag";
export const QANDP_THIRD_PARTY_DESIGNEE_OPTION =
  "q-p-third-party-designee-option";
export const QANDP_RESEND_ESIGN_DOCUMENT = "q-p-resend-e-sign-document";
export const QANDP_AGENT_SUPPORT_VIEW = "q-p-agent-support-view";
export const QANDP_PAPERLESS_ENROLLMENT_BUTTON =
  "q-p-paperless-enrollment-email-button";
export const QANDP_PRODUCER_MESSAGES_BUTTON = "q-p-producer-messages";
export const QANDP_WORKFLOW_JOBS = "q-p-workflow-jobs";
export const QANDP_PROFILES = "q-p-profiles";
export const QANDP_REMOVE_LOCK_FLAG = "q-p-remove-lock-flag";
export const QANDP_BINDING_PRODUCER_DATA = "q-p-binding-producer-data-source";
export const QANDP_AGENT_PORTAL_NOTICES = "q-p-agent-portal-notices";
export const QANDP_FNOL_COMPONENT = "q-p-fnol-component";
export const QANDP_PROCESS_TIME_SELECTOR = "q-p-process-time-selector";

export const FLAG_DEFAULTS = {
  [DISBURSEMENTS_ACH]: false,
  [BATCHES_ESCHEATMENTS]: false,
  [QANDP_POLICY_VITALS]: false,
  [REFERRALS_POWER_UP_STATUS_FILTER]: false,
  [REFERRALS_PRODUCT_FILTER]: false,
  [REFERRALS_STATE_FILTER]: false,
  [REFERRALS_LEGACY_LINK]: false,
  [REFERRALS_PIC_FILTER]: true,
  [REFERRALS_SURE_FILTER]: false,
  [REFERRALS_SRCH_FILTER]: false,
  [QANDP_ACCOUNTING_FORMS]: false,
  [QANDP_POLICY_MANAGER_FORMS]: false,
  [QANDP_PRINT_AND_MAIL_DOCUMENTS]: false,
  [QANDP_SAVE_ACH_INFO]: false,
  [QANDP_DOCUSIGN]: false,
  [QANDP_EASYPAY_INFO]: false,
  [QANDP_RENEWAL_UNDERWRITING]: false,
  [QANDP_UNDERWRITING_REFERRALS]: false,
  [QANDP_VIEW_ADVANCED]: false,
  [QANDP_POLICY_INSPECTIONS]: false,
  [QANDP_LEGACY_VIEW]: false,
  [QANDP_SERVICE_REQUESTS_DEMO]: false,
  [QANDP_MANAGE_ASSIGNEES]: false,
  [QANDP_PAST_TERMS]: false,
  [QANDP_ODEN_CANCELLATION]: false,
  [QANDP_VOID_PAYMENT]: false,
  [QANDP_RELOCATED_SUMMARY_BUTTONS]: false,
  [QANDP_PAPERLESS_ENROLLMENT]: {},
  [QANDP_SAME_DAY_MAIL]: false,
  [QANDP_QUOTING_SUPPORT]: false,
  [QANDP_QUOTING_SUPPORT_SAVE_BUTTON]: false,
  [QANDP_UNDERWRITING_CONDITIONS_SELECTOR]: false,
  [QANDP_NON_RENEW_INDICATOR]: false,
  [QANDP_DO_NOT_REINSTATE_FLAG]: false,
  [QANDP_THIRD_PARTY_DESIGNEE_OPTION]: false,
  [QANDP_RESEND_ESIGN_DOCUMENT]: false,
  [QANDP_AGENT_SUPPORT_VIEW]: false,
  [QANDP_PAPERLESS_ENROLLMENT_BUTTON]: false,
  [QANDP_PRODUCER_MESSAGES_BUTTON]: false,
  [QANDP_WORKFLOW_JOBS]: false,
  [QANDP_PROFILES]: false,
  [QANDP_REMOVE_LOCK_FLAG]: false,
  [QANDP_BINDING_PRODUCER_DATA]: false,
  [QANDP_AGENT_PORTAL_NOTICES]: false,
  [QANDP_FNOL_COMPONENT]: false,
  [QANDP_PROCESS_TIME_SELECTOR]: false
};
